import type * as React from 'react'
import type { AgentPriority } from '@axilon-apps/domains-ontology-ui-state'
import { cn } from '../../lib/utils'

/** Priority badge shared by inline task lists. */
export function TaskPriority({
  priority,
  emptyLabel
}: {
  priority: AgentPriority | null
  emptyLabel?: string
}): React.ReactElement | null {
  if (!priority) return emptyLabel ? <span className="text-12 text-ink-3">{emptyLabel}</span> : null
  return (
    <span
      className={cn(
        'inline-flex w-fit rounded px-1.5 py-0.5 text-12 font-medium capitalize',
        priority === 'critical'
          ? 'bg-st-down-bg text-st-down dark:text-red-300'
          : priority === 'high'
            ? 'bg-st-elev-bg text-st-elev dark:text-amber-300'
            : 'bg-bg-sunk text-ink-2'
      )}
    >
      {priority}
    </span>
  )
}
